import React from 'react';
import Comparision from "../../Components/Compare/Comparision";
import Footer from "../../Components/Footer/Footer";
import styled from "styled-components";

const Blog = () => {
    return (

        <Div>
            <Comparision/>
           <div className="footer">
               <Footer/>
           </div>
        </Div>
    );
};
const Div = styled.div`
  width: 100%;
  margin: auto;

  .footer {
  
    margin: auto;
    width: 100%;
    opacity: 0; 
    animation: showFooter 2s ease-in-out 8s forwards; 
    
  }

  @keyframes showFooter {
    to {
      opacity: 1; 
    }
  }



`
export default Blog;